/**
 * The Product component renders the product depending on the passed config.
 */
import React from 'react';
// import GeoHash from 'geo-hash';

import Map from '../../components/Map';
import Menu from '../../components/Menu';
import ShortcutMenu from '../../components/ShortcutMenu';
import LoadingPanel from '../../components/LoadingPanel';
import * as ProductActions from './ProductState';
import ProductDescription from '../../../../core_components/ProductDescription';
import Legend from '../../components/Legend';
import CoreProduct from '../../../../core_modules/Product/CoreProduct.js';
import Config from '../../Config.js';
import ConfigApi from '../../services/ConfigApi.js';
import classNames from 'classnames';
import './product.scss';

class Product extends CoreProduct {
  constructor(props) {
    super();
    const { dispatch } = props;

    this.setActiveLayer = (basemap) => {
      if (typeof basemap !== 'undefined') {
        dispatch(ProductActions.setActiveLayer(basemap));
      }
    };
    this.updateGeo = this.updateGeo.bind(this);
    this.descriptionHandler = this.descriptionHandler.bind(this);
  }

  updateGeo(theProps) {
    const urlGeo = (theProps.urlParams && theProps.urlParams.geo && theProps.urlParams.geo.length === 3) ? [parseFloat(theProps.urlParams.geo[0]), parseFloat(theProps.urlParams.geo[1]), parseInt(theProps.urlParams.geo[2], 10)] : null;
    const currentGeo = (this.props.zoom && this.props.center && this.props.center.length === 2) ? [parseFloat(this.props.center[0]), parseFloat(this.props.center[1]), parseInt(this.props.zoom, 10)] : null;
    const fallbackGeo = (window.maptoolConfig && window.maptoolConfig.zoom && window.maptoolConfig.center && window.maptoolConfig.center.length === 2) ? [parseFloat(window.maptoolConfig.center[0]), parseFloat(window.maptoolConfig.center[1]), parseInt(window.maptoolConfig.zoom, 10)] : Config.DEFAULT_GEO;
    if (!currentGeo && urlGeo) {
      this.props.dispatch(ProductActions.updateGeo(urlGeo));
    } else if (currentGeo && urlGeo) {
      if (urlGeo[0].toFixed(4) !== currentGeo[0].toFixed(4) || urlGeo[1].toFixed(4) !== currentGeo[1].toFixed(4) || urlGeo[2] !== currentGeo[2]) {
        this.props.dispatch(ProductActions.updateGeo(urlGeo));
      }
    } else if (!currentGeo && !urlGeo) {
      this.props.dispatch(ProductActions.updateGeo(fallbackGeo));
    }
  }

  descriptionHandler() {
    this.props.dispatch(ProductActions.toggleDescription());
  }

  componentWillMount() {
    this.updateGeo(this.props);

    const nextProduct = this.props.products.filter(p => p.id === this.props.productId)[0];
    this.props.dispatch(ProductActions.loadProductConfig(nextProduct));
  }

  componentWillReceiveProps(nextProps) {
    this.updateGeo(nextProps);

    // check if map view has changed, if not do not update this component
    // console.warn('nextProps', nextProps);
    if (nextProps.productId === this.props.productId) {
      return false;
    }
    const nextProduct = this.props.products.filter(p => p.id === nextProps.productId)[0];
    this.props.dispatch(ProductActions.loadProductConfig(nextProduct));
    document.getElementById(Config.rootDivId).dispatchEvent(new CustomEvent('product.change', { detail: nextProduct }));
  }

  componentDidMount() {
    this.leafletMap = this.refs.mapcontainer.leafletElement;
  }

  render() {
    const mapWrapperClasses = classNames(
      'mt-map-wrapper',
      {
        'mt-map-menu-open': this.props.isFakeFullscreenOpen,
      });
    return (
      <div className="mt-product bg--white">
        <div className="lap-m lap-pt palm-m- palm-pt- palm-mt0 lap-mt0">
          <div className={mapWrapperClasses}>
            <div className={`${this.props.isFakeFullscreenOpen ? 'fullscreen' : ''} mt-fullscreen-menu mt-fullscreen-wrapper`} >
              <Menu
                {...this.props}
              />
              <ShortcutMenu
                loadWarningsConfigFn={ConfigApi.loadWarningsConfig}
                urlParams={this.props.urlParams}
                legendVisible={this.props.legendVisible}
                basemaps={this.props.basemaps}
                dispatch={this.props.dispatch}
              />
              <Map
                ref="mapcontainer"
                id={this.props.id}
                title={this.props.title}
                headline={this.props.label}
                dataLayers={this.props.dataLayers}
                defaultBasemapId={this.props.urlParams.basemap.length ? this.props.urlParams.basemap[0] : this.props.defaultBasemapId}
                basemaps={this.props.basemaps}
                center={this.props.center}
                zoom={this.props.zoom}
                minZoom={this.props.minZoom}
                maxZoom={this.props.maxZoom}
                maxBounds={this.props.maxBounds}
                showFavorites={this.props.showFavorites}
                favorites={this.props.favorites}
                products={this.props.products}
                setActiveLayer={this.setActiveLayer}
                setNewZoom={ProductActions.setNewZoom}
                updateZoomLimits={ProductActions.updateZoomLimits}
                updateMaxBounds={ProductActions.updateMaxBounds}
                isFullScreen={this.props.isFullScreen}
                isFakeFullscreenOpen={this.props.isFakeFullscreenOpen}
                productFamilyId={this.props.productFamilyId}
                productFamilies={this.props.productFamilies}
                legendVisible={this.props.legendVisible}
                map_legend={this.props.map_legend}
                show_date={this.props.show_date}
                show_time={this.props.show_time}
              />
              <LoadingPanel />
            </div>
          </div>
          <div className="mt-upper-description lap-pt">
            <a className="mt-detail-link desk-hide lap-hide" onClick={this.descriptionHandler}>
              <span className="icon-question icon--huge"></span>
              <span className="pt">Details</span>
            </a>
          </div>
          <div className="mt-maptool-textwrapper">
            <div className={`${this.props.isDescriptionOpen ? 'fullscreen' : ''} mt-fullscreen-description palm-hide mt-fullscreen-wrapper`}>
              <div className="desk-hide lap-hide">
                <div className="icon-close mt-fake-fullscreen-close-button cursor--pointer" onClick={this.descriptionHandler} title="Schließen" />
              </div>
              <div className="mt-maptool-scrollablepanel one-whole mt-maptool-description-container">
                <ProductDescription
                  className="mt-maptool-description desk-two-thirds portable-one-whole desk-float--left"
                  title={this.props.title}
                  description={this.props.text}
                />
                <Legend
                  className="mt-maptool-legend desk-one-third portable-one-whole desk-float--left palm-ph pb"
                  headline={this.props.map_legend.headline}
                  ranges={this.props.map_legend.ranges}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Product.contextTypes = {
  router: React.PropTypes.object,
};

export default Product;



/** WEBPACK FOOTER **
 ** ./apps/maptool/modules/Product/Product.js
 **/